/**
 * CL-ACCESS-FINANCIALS-001B — Deterministic Accounting assignment preset (pure).
 *
 * Preset metadata is never authorization. applyAccountingPresetMetadataOnly() grants nothing.
 */

import {
  ASSIGNMENT_PRESET_ACCOUNTING,
  LEGACY_INVOICE_PERMISSION_KEY,
  PROJECT_ACCESS_SCOPE_CUSTOM,
  RESERVED_STAFF_FINANCIAL_PERMISSION_KEYS,
  SECTION_ACCESS_PERMISSION_KEYS,
  STAFF_FINANCIAL_MANAGE_PERMISSION_KEYS,
  STAFF_FINANCIAL_VIEW_PERMISSION_KEYS,
  STAFF_INVOICE_WORKFLOW_PERMISSION_KEYS,
} from "./projectStaffFinancialPermissionsModel";
import { CLIENT_PORTAL_MODULE_PERMISSION_KEYS } from "./clientPortalModuleApplicabilityModel";

function explicitFalseMap(keys = []) {
  return keys.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
}

/**
 * Build explicit Accounting preset values. Does not rely on missing-field defaults.
 */
export function buildAccountingAssignmentPreset() {
  const nonFinancialSections = SECTION_ACCESS_PERMISSION_KEYS.filter(
    (key) => key !== "canAccessFinancials" && key !== "canAccessTimeLog"
  );

  return {
    assignmentPreset: ASSIGNMENT_PRESET_ACCOUNTING,
    accessScope: PROJECT_ACCESS_SCOPE_CUSTOM,
    permissions: {
      ...explicitFalseMap(nonFinancialSections),
      canAccessOverview: false,
      canAccessFinancials: true,
      canAccessTimeLog: true,
      canViewInvoices: true,
      canViewBudget: true,
      canViewTimeLog: true,
      canPrepareInvoices: true,
      canReviewInvoices: true,
      ...explicitFalseMap(STAFF_FINANCIAL_MANAGE_PERMISSION_KEYS),
      canManageBudget: false,
      canManageTimeEntries: false,
      ...explicitFalseMap(
        STAFF_INVOICE_WORKFLOW_PERMISSION_KEYS.filter(
          (key) => key !== "canPrepareInvoices" && key !== "canReviewInvoices"
        )
      ),
      canApproveInvoices: false,
      canShareClientTest: false,
      canIssueInvoices: false,
      canManageInvoiceSettings: false,
      ...explicitFalseMap(RESERVED_STAFF_FINANCIAL_PERMISSION_KEYS),
      [CLIENT_PORTAL_MODULE_PERMISSION_KEYS.financials]: false,
      [LEGACY_INVOICE_PERMISSION_KEY]: true,
    },
  };
}

/**
 * Metadata-only patch — must not grant permissions by itself.
 */
export function applyAccountingPresetMetadataOnly(existing = {}) {
  return {
    ...existing,
    assignmentPreset: ASSIGNMENT_PRESET_ACCOUNTING,
    accessScope: PROJECT_ACCESS_SCOPE_CUSTOM,
  };
}

export function isAccountingAssignmentPreset(assignment = {}) {
  return String(assignment?.assignmentPreset || "").toLowerCase() === ASSIGNMENT_PRESET_ACCOUNTING;
}
